export const notificationsApi = (client) => ({
    list: (params) => client.get('/api/v1/notifications', { params }).then((r) => r.data),
    countUnread: () => client.get('/api/v1/notifications/count').then((r) => r.data),
    markRead: (id) => client.post(`/api/v1/notifications/${id}/read`).then((r) => r.data),
    markAllRead: () => client.post('/api/v1/notifications/read-all').then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/notifications/${id}`).then((r) => r.data),
    clearAll: () => client.delete('/api/v1/notifications').then((r) => r.data),
    getPreferences: () => client.get('/api/v1/notifications/preferences').then((r) => r.data),
    updatePreferences: (prefs) => client.patch('/api/v1/notifications/preferences', prefs).then((r) => r.data),
});
//# sourceMappingURL=notifications.js.map